/**
 * Macro colours for the Nutrition V2 screens.
 *
 * These come from the design mock (`מסך תזונה אדמין.html`) and deliberately differ from the
 * shared `macro` palette in `coachTokens`, which follows the client app's donut (carbs green,
 * fats amber). Keeping them here means V2 can match the design without restyling the old
 * nutrition pages or the food dictionary, which still read the shared one.
 *
 * The ROLES are fixed and predate the current mock — protein blue, carbs orange, fats purple,
 * fiber green. Only the saturation moved: the previous mock's hues were pure
 * (`#0071e3` / `#ff6b00`), and five of them side by side in one macro grid fought each other
 * for attention. These are the same four hues turned down far enough to read as a set.
 *
 * `text` is the number's colour, `soft` its tint, and `edge` the swatch beside the label.
 *
 * `short` is the one-letter form for places too tight for the word — the menus table's מקרו
 * column. It follows the abbreviations the app already ships (`coachTokens`, and the serving
 * pills in the food dictionary): ח׳ / פ׳ / ש׳ / ס׳, with the geresh U+05F3 and not an ASCII
 * apostrophe. These used to be two letters (חל׳ / פח׳ / …), which nothing ever rendered.
 */

import { t } from "../../../dashboard/coach/coachTokens";

export type MacroToken = {
  text: string;
  soft: string;
  edge: string;
  label: string;
  short: string;
};

export const macro: Record<"calories" | "protein" | "carbs" | "fats" | "fiber", MacroToken> = {
  // calories are not a macro — they read as plain text, with the brand green for totals
  calories: { text: t.text, soft: t.bg, edge: t.green, label: "קלוריות", short: "קל׳" },
  protein: { text: "#4B7BEC", soft: "rgba(75,123,236,.08)", edge: "#4B7BEC", label: "חלבון", short: "ח׳" },
  carbs: { text: "#E09A3C", soft: "rgba(224,154,60,.09)", edge: "#E09A3C", label: "פחמימות", short: "פ׳" },
  fats: { text: "#9B7BE0", soft: "rgba(155,123,224,.09)", edge: "#9B7BE0", label: "שומנים", short: "ש׳" },
  fiber: { text: "#57A96B", soft: "rgba(87,169,107,.09)", edge: "#57A96B", label: "סיבים", short: "ס׳" },
};
